import * as React from "react";
import styled, { css } from "styled-components";
import Icon from "components/common/Icon";
import { STATUS_ICONS } from "./healthStatusCopy";
const iconSize = {
  sm: "sm",
  md: void 0,
  lg: "lg"
};
const getColor = (status, theme) => {
  switch (status) {
    case "healthy":
      return theme.colors.variant.success;
    case "warning":
      return theme.colors.variant.warning;
    case "critical":
      return theme.colors.variant.danger;
    case "unknown":
    default:
      return theme.colors.gray[60];
  }
};
const StyledIcon = styled(Icon)(
  ({ $status }) => css`
    color: ${({ theme }) => getColor($status, theme)};
  `
);
const HealthStatusIcon = ({ className = void 0, size = "md", status, title = void 0 }) => /* @__PURE__ */ React.createElement(
  StyledIcon,
  {
    className,
    name: STATUS_ICONS[status],
    size: iconSize[size],
    $status: status,
    title,
    "aria-hidden": true
  }
);
export default HealthStatusIcon;
